import { CommonModule } from '@angular/common';
import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';

import { CoreModule } from '@alfresco/adf-core';
import { EXTENSION_DIRECTIVES } from '@alfresco/adf-extensions';

import { WkCoreExtensionService } from '../services/wk-core-extensions.service';

export function setupExtensions(service: WkCoreExtensionService): Function {
  return () => service.load();
}

@NgModule({
  imports: [CommonModule, CoreModule, ...EXTENSION_DIRECTIVES],
})
export class CoreExtensionsModule {
  static forRoot(): ModuleWithProviders<CoreExtensionsModule> {
    return {
      ngModule: CoreExtensionsModule,
      providers: [
        {
          provide: APP_INITIALIZER,
          useFactory: setupExtensions,
          deps: [WkCoreExtensionService],
          multi: true,
        },
      ],
    };
  }

  static forChild(): ModuleWithProviders<CoreExtensionsModule> {
    return {
      ngModule: CoreExtensionsModule,
    };
  }
}
